<section class="skills container">
  <div class="skills-pos">
    <h1 class="header-txt">{{ "skills.headline" | translate }}</h1>
  </div>
  <div class="icons-container">
    <p class="p-pos">
      {{ "skills.intro" | translate }}
    </p>
    <ul class="grid">
      <li class="skill">
        <img src="assets/img/icons/skill/angular.svg" alt="Angular" />
        <p>Angular</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/typeScript.svg" alt="TypeScript" />
        <p>TypeScript</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/javaScript.svg" alt="JavaScript" />
        <p>JavaScript</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/html.svg" alt="HTML" />
        <p>HTML</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/css.svg" alt="CSS" />
        <p>CSS</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/restApi.svg" alt="REST-API" />
        <p>REST-API</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/firebase.svg" alt="Firebase" />
        <p>Firebase</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/git.svg" alt="Git" />
        <p>Git</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/scrum.svg" alt="Scrum" />
        <p>Scrum</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/python.svg" alt="Python" />
        <p>Python</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/django.svg" alt="Django" />
        <p>Django</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/linux.svg" alt="Linux" />
        <p>Linux</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/redis.svg" alt="Redis" />
        <p>Redis</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/flask.svg" alt="Flask" />
        <p>Flask</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/postgreSql.svg" alt="PostgreSQL" />
        <p>PostgreSQL</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/sql.svg" alt="SQL" />
        <p>SQL</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/docker.svg" alt="Docker" />
        <p>Docker</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/cloud.svg" alt="Cloud" />
        <p>Cloud</p>
      </li>
      <li class="skill">
        <img src="assets/img/icons/skill/rxJs.svg" alt="RxJs" />
        <p>RxJs</p>
      </li>
      <li class="skill">
        <img
          src="assets/img/icons/skill/materialDesign.svg"
          alt="Material Design"
        />
        <p>Material Design</p>
      </li>
      <li class="skill skill-challenge">
        <img src="assets/img/icons/skill/challangeMe.svg" alt="Challenge me" />
        <p>{{ "work.skills.challangeMe" | translate }}</p>
      </li>
    </ul>
  </div>
  <div class="mobile">
    <p>
      {{ "work.mobile.intro" | translate }}
    </p>
    <div class="btn-container">
      <a class="btn" href="#contact">{{
        "work.mobile.button" | translate
      }}</a>
    </div>
  </div>
</section>

<img
  class="next-arrow"
  src="assets/img/icons/arrows/arrow_right.png"
  alt="Weiter"
  role="button"
  tabindex="0"
  (click)="onNext()"
  (keydown.enter)="onNext()"
  (keydown.space)="onNext()"
/>